import { formatTimestampHuman } from "../date-utils";
export const contactDtoFields = [{
        name: "name",
        title: "Nome",
        render: (record) => record.contact.fullName
    }, {
        name: "mainCompany",
        title: "Organizzazione Principale",
        render: (record) => record.mainCompanyId ? `<a href="/company/${record.mainCompanyId}">${record.mainCompanyName}</a>` : ''
        // }, {
        //   name: "relationDescription",
        //   title: "Relazione"
        // }, {
        //   name: "sourceDescription",
        //   title: "Sorgente"
    }, {
        name: "responsibleUser",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        title: "Responsabile"
    }, {
        name: "updatedBy",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        title: "Ultima Modifica"
    }, {
        name: "updatedOn",
        title: "Data Modifica",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatTimestampHuman(record.contact.updatedOn)
    }];
